import { IRole } from '@core/interfaces/role.interface';
import { ERoles } from '@enums/roles.enum';

/**
 * Icon for a role from `GET /roles` (or any lightweight object with the same shape) - exactly 3
 * icons total: the built-in `campaign` role gets its own icon, every other built-in role (in
 * practice just `campaign_sub`) gets the plain person icon, and every custom (group-owned) role -
 * `userGroupId` set - shares one icon regardless of how many custom roles exist.
 */
export function getRoleIcon(role: Pick<IRole, 'id' | 'userGroupId'>): string {
  if (role.userGroupId) {
    return '/icons/user-cog.svg';
  }

  return role.id === (ERoles.campaign as string) ? '/icons/user-key.svg' : '/icons/user.svg';
}
